module.exports = __webpack_public_path__ + "img/closebtn-icon-active.887de4f0.svg";